import React, { useRef, useEffect } from 'react'
import MiniDrawer from '../header/Drawer'
import { Outlet, useLocation, useNavigate } from 'react-router'
import SupportSessionBanner from '../organisation/SupportSessionBanner'
import InviteNotice from '../organisation/InviteNotice'
import PlanStatus from '../subscription/PlanStatus'
import OrgInactiveGate from '../organisation/OrgInactiveGate'
import { readSession } from '../../utils/organisationApi'

const MainLayout = () => {
  const mainContentRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { isSuperAdmin } = readSession();
  const inviteNotice = location.state?.inviteNotice || "";
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === '#main-content' && mainContentRef.current) {
        mainContentRef.current.focus();
      }
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleSkipClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.hash = 'main-content';
    
    if (mainContentRef.current) {
      mainContentRef.current.focus();
    }
  };

  return (
    <section className='flex justify-between w-screen h-screen overflow-hidden'>
      <div 
        id="top-content"
        tabIndex={-1}
        aria-hidden="true"
        className="sr-only"
      />
      <a
        href="#main-content"
        className="skip-link"
        onClick={handleSkipClick}
        role="button"
        tabIndex={0}
      >
        Skip to main content
      </a>
      <MiniDrawer />

      <div ref={mainContentRef} id="main-content" tabIndex={-1} role="main" className="flex-1 overflow-hidden flex flex-col">
        {isSuperAdmin && <SupportSessionBanner />}
        <PlanStatus />
        <OrgInactiveGate />
        <InviteNotice
          message={inviteNotice}
          onDismiss={() => navigate(`${location.pathname}${location.search}`, { replace: true, state: {} })}
        />
        <div className="flex-1 overflow-hidden">
          <Outlet />
        </div>
      </div>
    </section>
  )
}

export default MainLayout
